import type { AuditEvent, TraceabilityEvent } from "@swot/swot-components";
import { readDateIso, readString } from "./mapperUtils.js";

export function mapAuditEvent(dto: unknown): AuditEvent {
  return {
    id: readString(dto, ["id", "auditId", "eventId"], ""),
    eventType: readString(dto, ["eventType", "action", "actionCode"], "UNKNOWN"),
    actorId: readString(dto, ["actorId", "userId", "createdBy"], "system"),
    occurredAt: readDateIso(dto, ["occurredAt", "occurredAtUtc", "createdAtUtc"], ""),
    summary: readString(dto, ["summary", "description", "message"], "Audit event recorded"),
    recordId: readString(dto, ["recordId", "complaintId", "entityId"], ""),
    hash: readString(dto, ["hash", "sha256Hash"], ""),
  };
}

export function mapTraceabilityEvent(dto: unknown): TraceabilityEvent {
  return {
    id: readString(dto, ["id", "traceabilityId", "eventId"], ""),
    sourceRecordId: readString(dto, ["sourceRecordId", "sourceId", "complaintId"], ""),
    targetRecordId: readString(dto, ["targetRecordId", "targetId", "linkedRecordId"], ""),
    linkType: readString(dto, ["linkType", "relationType"], "RELATED"),
    occurredAt: readDateIso(dto, ["occurredAt", "createdAtUtc"], ""),
    actorId: readString(dto, ["actorId", "createdBy"], "system"),
  };
}
